import React from "react";

const MobileDisplayContext = React.createContext({
    mobileDisplay:false,
    setMobileDisplay:()=>{}
})

export default MobileDisplayContext